import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Icon } from 'platfi-ui-components';

import { bemClassName } from 'utils/BEMHelper';

import styles from './ShareableReportRequirementItem.scss';

const ShareableReportRequirementItem = ({ icon, title, italic }) => (
  <div styleName="m-shareable-requirement-item">
    <Icon
      icon={icon}
      className="a-svg-small"
      styleName={`m-shareable-requirement-item__${icon}-icon`}
    />
    <span styleName={bemClassName('m-shareable-requirement-item__title', { italic })}>{title}</span>
  </div>
);

ShareableReportRequirementItem.propTypes = {
  icon: PropTypes.string,
  italic: PropTypes.bool,
  title: PropTypes.string,
};

ShareableReportRequirementItem.defaultProps = {
  icon: 'declined',
};

export default CSSModules(ShareableReportRequirementItem, styles, { allowMultiple: true });
